import { render, staticRenderFns } from "./selectPoint.vue?vue&type=template&id=49825b19&"
import script from "./selectPoint.vue?vue&type=script&lang=js&"
export * from "./selectPoint.vue?vue&type=script&lang=js&"
import style0 from "./selectPoint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports